var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInvestmentAccountSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#bda6cc",
    xmlns: "http://www.w3.org/2000/svg",
    width: "800px",
    height: "800px",
    viewBox: "0 0 100 100",
    enableBackground: "new 0 0 100 100",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74,27H26c-3.3,0-6,2.7-6,6v34c0,3.3,2.7,6,6,6h48c3.3,0,6-2.7,6-6V33C80,29.7,77.3,27,74,27z M69,54 c0,0.9-1,1.3-1.7,0.7l-4.6-4.6l-10.6,9.1c-1.2,1.2-3.1,1.2-4.2,0l-6.4-7.3l-11.4,10c-0.4,0.4-1,0.4-1.4,0l-0.5-0.5 c-0.4-0.4-0.4-1,0-1.4l11.2-15.3c1.2-1.2,3.1-1.2,4.2,0l6.4,6.4l6.5-7.5l-4.2-3.8c-0.6-0.6-0.2-1.8,0.7-1.8h14c1.1,0,1.9,1,1.9,2.1 V54z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentAccountSvgrepoCom);
export default __webpack_public_path__ + "static/media/investment-account-svgrepo-com.498b75fa50c7537427faa959b70cd6e4.svg";
export { ForwardRef as ReactComponent };